import type { Hook } from '../types';

export function globalConfig(...args: Parameters<Hook['globalConfig']>) {
  return {
    hxKLineVerifyInfo: {}
  } as ReturnType<Hook['globalConfig']>;
}

export default globalConfig;
